export const ANIMATIONS = {
  FEMININE: {
    IDLE: '/glb/feminine/F_Standing_Idle_001.fbx',
  },
  MASCULINE: {
    IDLE: '/glb/masculine/M_Standing_Idle_001.fbx',
  },
}
